var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('income-upload-page',{attrs:{"page":_vm.MULTI_LOAN_INCOME_ROUTE,"loading":_vm.loading},on:{"update:loading":function($event){_vm.loading=$event},"submit":_vm.submitForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }